import { t } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { capitalize, identity } from 'lodash';
import PropTypes from 'prop-types';
import { Header, Icon } from 'semantic-ui-react';

import { useConceptParentLabelFormatter } from 'reducers/entityLabelFormatter';

import commonPropTypes from 'utils/commonPropTypes';

import * as svars from 'assets/style/variables';

function ConceptCell({ value, row: { original } }) {
  const { i18n } = useLingui();
  const onLegendClick = true;
  const conceptParentLabelFormatter = useConceptParentLabelFormatter(
    identity,
    capitalize(i18n._(t({ id: 'concept-global' })))
  );
  const parentConcept = conceptParentLabelFormatter(original?.id);
  return (
    <Header
      as="h5"
      image
      style={{
        width: '100%',
        overflow: 'hidden',
        fontWeight: svars.fontWeightSemiBold,
      }}
    >
      <Header.Content
        style={{
          width: 'inherit',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <span style={{ display: 'inline-flex' }}>
          <span style={{ flexGrow: 1, marginRight: svars.spaceMedium }}>
            {value}
          </span>
          {onLegendClick ? (
            <Icon data-html2canvas-ignore="true" name="chevron right" />
          ) : null}
        </span>
        <Header.Subheader
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <span
            style={{
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}
          >
            <Icon name="fork" style={{ margin: 0 }} /> {parentConcept || '-'}
          </span>
        </Header.Subheader>
      </Header.Content>
    </Header>
  );
}

ConceptCell.propTypes = {
  value: commonPropTypes.concept.isRequired,
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

ConceptCell.defaultProps = {};

export default ConceptCell;
